export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'action', name: '动作片', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'romance', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'scifi', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'animation', name: '动画片', icon: 'ri-magic-line' },
  { slug: 'drama', name: '剧情片', icon: 'ri-film-line' },
  { slug: 'suspense', name: '悬疑片', icon: 'ri-search-eye-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
];

export const movies = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    originalTitle: 'The Wandering Earth 3',
    year: 2026,
    category: 'scifi',
    rating: 9.2,
    duration: '148分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20floating%20in%20space%2C%20earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20orange%20and%20deep%20blue%20tones%2C%20movie%20poster%20style%2C%20clean%20design%2C%20no%20text&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，一群勇敢的航天员挺身而出，为了人类的存亡而战。这是一部震撼人心的中国科幻史诗巨作，延续了前作的宏大世界观，视觉效果达到全新高度。故事围绕人类文明的延续与牺牲精神展开，影片中的每一帧画面都经过精心打磨，从地下城的宏伟场景到外太空的壮丽星云，无不展现中国科幻电影的顶尖制作水准。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    featured: true,
    latest: true,
    hot: true,
  },
  {
    id: 'movie-2',
    title: '长安三万里',
    originalTitle: 'Chang An',
    year: 2025,
    category: 'animation',
    rating: 8.9,
    duration: '168分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20ancient%20Tang%20Dynasty%20Changan%20city%20with%20poets%20in%20traditional%20robes%2C%20warm%20golden%20and%20crimson%20tones%2C%20artistic%20ink%20wash%20painting%20style%2C%20cinematic%20movie%20poster%2C%20elegant%20composition&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利。困守孤城的高适向监军太监回忆起自己与李白的一生往事。影片以壮丽的中国风动画重现大唐盛世，将唐诗的意境之美通过视觉化方式呈现给观众，让人沉浸在那个诗酒趁年华的黄金时代。',
    director: '追光动画',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    featured: true,
    latest: true,
    hot: false,
  },
  {
    id: 'movie-3',
    title: '封神第二部',
    originalTitle: 'Creation of the Gods II',
    year: 2025,
    category: 'action',
    rating: 8.7,
    duration: '152分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20warriors%20in%20ancient%20armor%20riding%20mythical%20beasts%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20color%20palette%2C%20dramatic%20cinematic%20lighting%2C%20blockbuster%20movie%20poster%20style&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    description: '殷商大军压境，西岐军民奋起抵抗。姜子牙率领哪吒、杨戬等诸神相助，一场惊天动地的神魔大战即将展开。本片是中国神话史诗电影的巅峰之作，宏大的战争场面和精美的视觉效果，将中国古典神话的魅力展现得淋漓尽致。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    featured: true,
    latest: false,
    hot: true,
  },
  {
    id: 'movie-4',
    title: '热辣滚烫',
    originalTitle: 'YOLO',
    year: 2025,
    category: 'comedy',
    rating: 8.3,
    duration: '129分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy-drama%20movie%20poster%20with%20a%20woman%20boxing%20in%20a%20gym%2C%20warm%20uplifting%20tone%2C%20soft%20lighting%2C%20inspirational%20atmosphere%2C%20movie%20poster%20design%2C%20clean%20modern%20style&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    description: '乐莹是一个善良的女孩，却总是被生活辜负。在与家人和朋友的相处中，她逐渐失去了自我。直到她遇到了拳击——这项运动让她找到了人生的方向。她决定用拳击来改变自己，重新找回生活的掌控权。一部温暖治愈的喜剧片，笑中带泪。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    featured: false,
    latest: true,
    hot: true,
  },
  {
    id: 'movie-5',
    title: '人生大事',
    originalTitle: 'Lighting Up The Stars',
    year: 2024,
    category: 'drama',
    rating: 9.0,
    duration: '112分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20drama%20movie%20poster%20of%20a%20man%20and%20a%20little%20girl%20walking%20together%20in%20a%20narrow%20alley%2C%20warm%20sunset%20light%2C%20emotional%20and%20touching%20atmosphere%2C%20cinematic%20photography%2C%20soft%20filmic%20tones&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    description: '殡葬师莫三妹遇到了孤儿武小文，两个毫不相干的人在相处中逐渐改变了对生命的看法。影片以温情幽默的方式探讨生死话题，展现了中国人对待生死的独特哲学，是一部既感人又治愈的佳作。',
    director: '刘江江',
    actors: ['朱一龙', '杨恩又', '王戈'],
    featured: false,
    latest: false,
    hot: true,
  },
  {
    id: 'movie-6',
    title: '独行月球',
    originalTitle: 'Moon Man',
    year: 2024,
    category: 'comedy',
    rating: 8.5,
    duration: '122分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=A%20comedy%20sci-fi%20movie%20poster%20with%20an%20astronaut%20standing%20alone%20on%20the%20moon%20surface%2C%20earth%20in%20the%20distant%20background%2C%20humorous%20tone%2C%20cool%20silver%20and%20blue%20color%20palette%2C%20cinematic%20style&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    description: '人类为阻止小行星撞击地球，部署了月盾计划。维修工独孤月被意外遗忘在月球上，成为"月球上最后一个人"。他在月球上开始了爆笑又孤独的生存之旅。沈腾的独角戏让人捧腹大笑，同时又不乏对孤独与人性的深刻探讨。',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '黄才伦'],
    featured: false,
    latest: false,
    hot: true,
  },
  {
    id: 'movie-7',
    title: '我爱你！',
    originalTitle: 'Love Never Ends',
    year: 2025,
    category: 'romance',
    rating: 8.8,
    duration: '116分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20movie%20poster%20with%20elderly%20couple%20holding%20hands%20in%20a%20park%20at%20sunset%2C%20warm%20golden%20light%2C%20tender%20and%20touching%20atmosphere%2C%20emotional%20depth%2C%20cinematic%20film%20poster%20design&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    description: '四位花甲老人，两段迟暮之恋。他们的爱善良而纯粹、浪漫又浓烈，在生命尽头，用力而纯粹地相爱。影片打破了人们对老年人爱情的刻板印象，用细腻的镜头语言讲述了跨越年龄的浪漫故事，令人动容。',
    director: '韩延',
    actors: ['倪大红', '惠英红', '梁家辉', '叶童'],
    featured: false,
    latest: true,
    hot: false,
  },
  {
    id: 'movie-8',
    title: '消失的她',
    originalTitle: 'Lost in the Stars',
    year: 2024,
    category: 'suspense',
    rating: 8.6,
    duration: '121分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20movie%20poster%20with%20a%20woman%20looking%20through%20a%20rain-soaked%20window%2C%20mysterious%20dark%20atmosphere%2C%20deep%20blue%20and%20purple%20tones%2C%20tense%20mood%2C%20cinematic%20thriller%20poster%20design&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子突然现身，但何非坚持眼前的陌生女人并非妻子。随着金牌律师陈麦的介入，更多谜团浮现。一场关于真相与谎言的烧脑较量就此展开。',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    featured: false,
    latest: false,
    hot: true,
  },
  {
    id: 'movie-9',
    title: '孤注一掷',
    originalTitle: 'No More Bets',
    year: 2024,
    category: 'suspense',
    rating: 8.4,
    duration: '130分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20movie%20poster%20with%20a%20person%20trapped%20behind%20computer%20screens%2C%20dark%20oppressive%20atmosphere%2C%20red%20warning%20tones%2C%20digital%20dystopia%20feel%2C%20gritty%20cinematic%20style&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，出国淘金却意外卷入境外诈骗工厂的陷阱。影片取材自上万起真实诈骗案例，揭开境外网络诈骗的全产业链内幕，具有强烈的社会警示意义。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    featured: false,
    latest: true,
    hot: false,
  },
  {
    id: 'movie-10',
    title: '熊出没·逆转时空',
    originalTitle: 'Boonie Bears: Time Twist',
    year: 2025,
    category: 'animation',
    rating: 8.2,
    duration: '99分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20animated%20family%20movie%20poster%20with%20two%20bears%20and%20a%20man%20on%20time%20travel%20adventure%2C%20bright%20vibrant%20colors%2C%20playful%20and%20fun%20tone%2C%20animated%20film%20poster%20design%2C%20family-friendly&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    description: '光头强是一名普通程序员，却常梦见陌生的森林和两头狗熊。直到他跟上司出访大客户，终于想起：他原是森林的小导游，偶然得到一次重新选择人生的机会。为了挽救旧时间线里的熊大熊二，光头强开始了一场奇妙的时空冒险。',
    director: '林汇达',
    actors: ['谭笑', '张伟', '张秉君'],
    featured: false,
    latest: true,
    hot: false,
  },
  {
    id: 'movie-11',
    title: '满江红',
    originalTitle: 'Full River Red',
    year: 2024,
    category: 'drama',
    rating: 8.8,
    duration: '159分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20period%20movie%20poster%20set%20in%20Song%20Dynasty%20with%20soldiers%20in%20ancient%20courtyard%2C%20dark%20red%20and%20black%20tones%2C%20dramatic%20lighting%2C%20intense%20historical%20drama%20feel&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相府邸，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入这场阴谋之中。一场关于忠诚与背叛的博弈，在幽深的宰相府中徐徐展开。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    featured: false,
    latest: false,
    hot: true,
  },
  {
    id: 'movie-12',
    title: '巨齿鲨2：深渊',
    originalTitle: 'Meg 2: The Trench',
    year: 2025,
    category: 'action',
    rating: 7.8,
    duration: '119分钟',
    language: '英语',
    region: '美国/中国',
    poster: 'https://readdy.ai/api/search-image?query=Action%20monster%20movie%20poster%20with%20giant%20prehistoric%20shark%20rising%20from%20deep%20ocean%2C%20underwater%20menace%2C%20dark%20blue%20ocean%20tones%2C%20thrilling%20adventure%20feel%2C%20blockbuster%20poster%20design&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    description: '乔纳斯·泰勒与科学家张九溟潜入深海7000米，探索未知的深渊世界。他们遭遇了史前巨齿鲨群和更多深海怪物的袭击。一场惊心动魄的海底求生之旅，将巨兽灾难片的紧张刺激发挥到极致。',
    director: '本·维特利',
    actors: ['杰森·斯坦森', '吴京', '蔡书雅'],
    featured: false,
    latest: false,
    hot: false,
  },
  {
    id: 'movie-13',
    title: '八角笼中',
    originalTitle: 'Octagonal',
    year: 2024,
    category: 'drama',
    rating: 8.6,
    duration: '117分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20sports%20drama%20movie%20poster%20with%20young%20fighters%20in%20a%20boxing%20ring%2C%20raw%20and%20gritty%20style%2C%20warm%20earthy%20tones%2C%20powerful%20emotional%20impact%2C%20cinematic%20film%20poster&width=600&height=840&seq=movie-poster-13&orientation=portrait',
    description: '向腾辉倾注心血想把当地无人照料的孩子培养成才，这让生活本没有出路的孩子们看到了一丝通向未来的光。然而随着往日的表演视频被爆出，这些"残忍血腥"的画面刺激了不明真相的人们的神经。一夜之间，舆论开始发酵。',
    director: '王宝强',
    actors: ['王宝强', '陈永胜', '史彭元', '王迅'],
    featured: false,
    latest: false,
    hot: false,
  },
  {
    id: 'movie-14',
    title: '深海',
    originalTitle: 'Deep Sea',
    year: 2024,
    category: 'animation',
    rating: 8.4,
    duration: '112分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Dreamy%20Chinese%20animated%20fantasy%20movie%20poster%20with%20a%20girl%20floating%20in%20a%20colorful%20underwater%20world%20full%20of%20glowing%20jellyfish%20and%20coral%2C%20vivid%20saturated%20colors%2C%20surreal%20beautiful%20art%20style&width=600&height=840&seq=movie-poster-14&orientation=portrait',
    description: '一个叫参宿的女孩意外坠入深海世界，在那里遇到了一个叫南河的男孩。两人一起踏上了一场关于勇气与成长的奇幻冒险之旅。影片以惊艳的粒子水墨画风打造了一个前所未有的深海世界，视觉效果令人叹为观止。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文', '滕奎兴'],
    featured: false,
    latest: false,
    hot: false,
  },
  {
    id: 'movie-15',
    title: '周处除三害',
    originalTitle: 'The Pig, The Snake and The Pigeon',
    year: 2024,
    category: 'action',
    rating: 8.5,
    duration: '134分钟',
    language: '国语',
    region: '中国台湾',
    poster: 'https://readdy.ai/api/search-image?query=Gritty%20Taiwanese%20action%20crime%20movie%20poster%20with%20a%20lone%20man%20walking%20through%20dark%20city%20streets%2C%20neon-lit%20night%20atmosphere%2C%20intense%20moody%20tones%2C%20raw%20thriller%20aesthetic%2C%20cinematic%20poster%20design&width=600&height=840&seq=movie-poster-15&orientation=portrait',
    description: '通缉犯陈桂林生命将尽，却发现自己在通缉榜上只排名第三。他决心查出前两名通缉犯的下落，将他们一一除掉。一场酣畅淋漓的黑暗复仇之旅，以暴制暴的爽感让观众血脉贲张。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文'],
    featured: true,
    latest: false,
    hot: false,
  },
  {
    id: 'movie-16',
    title: '年会不能停！',
    originalTitle: 'Johnny Keep Walking!',
    year: 2025,
    category: 'comedy',
    rating: 8.7,
    duration: '117分钟',
    language: '国语',
    region: '中国大陆',
    poster: 'https://readdy.ai/api/search-image?query=Comedic%20Chinese%20office%20workplace%20movie%20poster%20with%20employees%20celebrating%20at%20company%20annual%20party%2C%20bright%20festive%20colors%2C%20humorous%20chaotic%20energy%2C%20modern%20corporate%20satire%20style&width=600&height=840&seq=movie-poster-16&orientation=portrait',
    description: '钳工胡建林阴差阳错被调入集团总部，与格格不入的职场环境发生了系列令人啼笑皆非的故事。影片以犀利幽默的方式讽刺了当代职场文化，让每一个打工人都能心领神会地笑出声来。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲', '王迅'],
    featured: false,
    latest: true,
    hot: false,
  },
];

export const testimonials = [
  {
    id: 't1',
    author: '影迷小张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20man%20with%20friendly%20smile%2C%20clean%20studio%20portrait%2C%20warm%20lighting&width=100&height=100&seq=avatar-t1&orientation=squarish',
    rating: 5,
    content: '神马影院画质太棒了！高清不卡顿，追剧体验一级棒。资源更新也很快，新片上线速度在同类平台中名列前茅。',
    date: '2025-06-15',
  },
  {
    id: 't2',
    author: '剧迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20in%20her%20twenties%2C%20warm%20genuine%20smile%2C%20clean%20studio%20portrait%2C%20soft%20lighting&width=100&height=100&seq=avatar-t2&orientation=squarish',
    rating: 5,
    content: '界面简洁干净，没有烦人的弹窗广告，这点真的太难得了。分类也很清晰，找片特别方便，全家都在用！',
    date: '2025-05-28',
  },
  {
    id: 't3',
    author: '电影达人老李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle-aged%20Chinese%20man%2C%20confident%20expression%2C%20clean%20studio%20portrait%2C%20natural%20lighting&width=100&height=100&seq=avatar-t3&orientation=squarish',
    rating: 5,
    content: '作为一个看了20年电影的老影迷，神马影院的片源质量真的没话说。高清播放流畅不缓冲，比很多付费平台都好用。强烈推荐！',
    date: '2025-05-10',
  },
  {
    id: 't4',
    author: '追剧少女小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20woman%20with%20bright%20smile%2C%20clean%20studio%20portrait%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-t4&orientation=squarish',
    rating: 4,
    content: '电视剧更新特别及时，热门剧集同步上线。而且支持断点续播，看一半下次接着看，非常人性化。',
    date: '2025-04-22',
  },
  {
    id: 't5',
    author: '数码博主阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20tech-savvy%20man%2C%20modern%20stylish%20portrait%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-t5&orientation=squarish',
    rating: 5,
    content: '技术层面做得非常好，加载速度快，播放器响应迅速。在手机上用4G看也完全不卡，技术实力过硬。',
    date: '2025-04-05',
  },
];

export const faqs = [
  {
    question: '神马影院需要下载APP才能观看吗？',
    answer: '不需要！神马影院支持即点即播，无需下载任何软件或插件。您只需要打开浏览器，访问我们的网站，即可在线观看海量高清电影和电视剧。我们采用先进的流媒体传输技术，确保播放流畅不卡顿。',
  },
  {
    question: '神马影院的视频画质如何？',
    answer: '神马影院提供1080P全高清画质，部分热门影片支持4K超清画质。我们采用智能码率自适应技术，会根据您的网络状况自动调整最佳画质，确保在保证清晰度的同时实现流畅播放。',
  },
  {
    question: '观看视频需要付费吗？',
    answer: '神马影院上的大部分内容都是免费观看的。我们致力于为广大用户提供免费高清的观影体验。部分独家内容可能需要会员观看，但我们保证免费内容的比例远高于行业平均水平。',
  },
  {
    question: '神马影院的影片更新速度如何？',
    answer: '我们的内容团队7x24小时不间断更新，热门电影和电视剧在上线后24小时内即可在神马影院观看。院线新片下映后也会在第一时间上线，确保您不会错过任何精彩内容。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '神马影院全面支持PC电脑、平板、手机等各类设备。无论是在家中的大屏幕上观看，还是通勤时用手机追剧，都能获得优质的观影体验。我们的网站采用响应式设计，自动适配不同屏幕尺寸。',
  },
  {
    question: '播放卡顿怎么办？',
    answer: '如果您遇到播放卡顿的情况，建议尝试以下方法：1）检查网络连接是否稳定；2）降低视频清晰度档位；3）刷新页面重新加载；4）更换浏览器尝试。绝大多数情况下，神马影院的视频都能流畅播放。如仍有问题，欢迎联系客服。',
  },
];